import classNames from 'classnames';
import { FlexContainer, Txt } from 'components';
import styles from './ErrorStatus.module.scss';

/**
 * ErrorStatus
 *
 * @return {JSX.Element}
 */
const ErrorStatus = ({ className }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.ErrorStatus,
        className,
        ErrorStatus.displayName
      )}
      column
      gap
    >
      <Txt bold>⚠️ Error in agreement process</Txt>
      <Txt>During the signing process one of a few errors can appear:</Txt>
      <Txt regular>- A signer has declined to sign the contract.</Txt>
      <Txt regular>- Contract has been withdrawn.</Txt>
      <Txt regular>
        Our team have been made aware of this issue. We will contact you with
        further information and instructions. Sorry about the inconvenience.
      </Txt>
    </FlexContainer>
  );
};

ErrorStatus.displayName = 'ErrorStatus';

export default ErrorStatus;
